import React, {  useState } from "react";
import strings from "../../utils/property-file/setting.json";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import api from '../../services/api';
import constants from "../../utils/constants";

export default function ChangePassword() {
  const nav = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [passwordUpdated , passwordUpdating] = useState(false);
  const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
  
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  function handlePassword() {
    setShowPassword((prevShowPassword) => !prevShowPassword);
    
  }
  function handleConfirmPassword() {
    setShowConfirmPassword((prevShowPassword) => !prevShowPassword);
    
  }
  function handleOldPassword() {
  setShowOldPassword((prevShowPassword) => !prevShowPassword);
  }
  const newPassword = watch('password'); 
  const confirmPassword = watch('confirmPassword');

  const changeLoginPassword = async (data)=>
  {
   
    try{
      let body={
        newPassword : data.password,
        oldPassword : data.oldPassword
      }
      passwordUpdating(true);
      const response= await api.changeLoginPassword(body)
      if(response && response.data)
      {
        const data=JSON.parse(response.data)
        if(response.success)
        {
        toast.success(data.body, { toastId: "error14" });
        reset();
        }
        
        else 
        {
          toast.error(data.body, { toastId: "error6" });
          if(response.status_code===440)
          {
          localStorage.clear();
          nav(constants.navigationLink.loginLink)
          passwordUpdating(false);
          toast.error(data.body, { toastId: "error6" });
        
          }
        }
        passwordUpdating(false);
      }
      else{
        passwordUpdating(false);
        toast.error(response.message, { toastId: "error6" });
      }

    }
    catch(error)
    {
      passwordUpdating(false);
    }
  }

  return (
    <div>
      <div className="setting-details-sub-container mt-3">
        <div className="security-feature">
          <div className="password-change-feature">
            <p className="feature-name"><div onClick={(()=>{ nav(constants.navigationLink.setting) })} className="back-setting-arrow d-inline"><i className="ri-arrow-left-line"></i></div> {strings.securityLabel}</p>
            <div className="input-box-change-password">
              <form onSubmit={handleSubmit(changeLoginPassword)}>
          <div className="change-password-input">
          <div className="form-floating input-gap row">
                  <input
                    {...register("oldPassword", {
                      required: strings.oldPasswordRequired,

                    })}
                    type={showOldPassword ? "text" : "password"}
                    
                    className={
                      errors.oldPassword
                        ? "form-control validateEmail email-input input-text-alert add-employee-input-text pb-0"
                        : "form-control validateEmail email-input pb-0 add-employee-input-text"
                    }
                    placeholder=" "
                    autoComplete="off"
                  />
                  <label
                    htmlFor="floating-input"
                    className="text-light input-place"
                  >
                  {strings.oldPasswordLabel}
                  </label>
                  {showOldPassword ? (
                    <i
                      onClick={handleOldPassword}
                      className="ri-eye-line password-eye text-end"
                    ></i>
                  ) : (
                    <i
                      onClick={handleOldPassword}
                      className="ri-eye-close-line password-eye text-end"
                    ></i>
                  )}

                  <div className="form-validation p-0">
                    <small>
                      {errors.oldPassword && (
                        <span>
                          <strong>&#9432;</strong>
                          {errors.oldPassword.message}
                        </span>
                      )}
                    </small>
                  </div>
                </div>


                <div className="form-floating input-gap row">
                  <input
                    {...register("password", {
                      required: strings.newPasswordRequired,
                     
                      pattern :{
                        value : passwordPattern ,
                        message : "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, and one digit.",
                      }
              
                    })}
                    type={showPassword ? "text" : "password"}
                    
                    className={
                      errors.password
                        ? "form-control validateEmail email-input input-text-alert add-employee-input-text pb-0"
                        : "form-control validateEmail email-input pb-0 add-employee-input-text"
                    }
                    placeholder=" "
                    autoComplete="off"
                  />
                  <label
                    htmlFor="floating-input"
                    className="text-light input-place"
                  >
                    {strings.newPasswordLabel}
                  </label>
                  {showPassword ? (
                    <i
                      onClick={handlePassword}
                      className="ri-eye-line password-eye text-end"
                    ></i>
                  ) : (
                    <i
                      onClick={handlePassword}
                      className="ri-eye-close-line password-eye text-end"
                    ></i>
                  )}

                  <div className="form-validation p-0">
                    <small>
                      {errors.password && (
                        <span>
                          <strong>&#9432;</strong>
                          {errors.password.message}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
                <div className="form-floating input-gap row">
                  <input
                    {...register("confirmPassword", {
                      required: strings.confirmPasswordRequired,
                     
                
                    })}
                    type={showConfirmPassword ? "text" : "password"}
                    
                    className={
                      errors.confirmPassword
                        ? "form-control validateEmail email-input input-text-alert add-employee-input-text pb-0"
                        : "form-control validateEmail email-input pb-0 add-employee-input-text"
                    }
                    placeholder=" "
                    autoComplete="off"
                
                  />
                  <label
                    htmlFor="floating-input"
                    className="text-light input-place"
                  >
                   {strings.confirmPasswordLabel}
                  </label>
                  {showConfirmPassword ? (
                    <i
                      onClick={handleConfirmPassword}
                      className="ri-eye-line password-eye text-end"
                    ></i>
                  ) : (
                    <i
                      onClick={handleConfirmPassword}
                      className="ri-eye-close-line password-eye text-end"
                    ></i>
                  )}

                  <div className="form-validation p-0">
                    <small>
                      {errors.confirmPassword && (
                        <span>
                          <strong>&#9432;</strong>
                          {errors.confirmPassword.message}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
                        
                {newPassword !== confirmPassword && (
                  <div className="form-validation p-0">
                    <small>
                      <span>
                        <strong>&#9432;</strong>
                        {strings.passwordMatchError}
                      </span>
                    </small>
                  </div>)}

                <div className="button-change-password ">
                        {passwordUpdated ?(<button type="submit" disabled><div className="spinner-border spinner-border-sm text-light" role="status"><span className="sr-only"></span></div> </button>):(<button type="submit">{strings.changePasswordLabel}</button>)}
                </div>
                 </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}